import React from "react";
import PropTypes from "prop-types";
import CircleButton from "../../commons/CircleButton";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import { removeRecurrentSubsidy } from "../../../../usecases/benefit-model/remove-recurrent-subsidy";
import { translate as t } from "../../../../infrastructure/translate/localization";

const RemoveSubsidyRecurrentModal = ({ modelBenefit }) => {
  return (
    <div className="modal-container">
      <CircleButton
        className="primary close-modal"
        icon="times"
        handlerClick={() => hideModal()}
      />
      <div className="modal-content">
        <div className="modal-left-line" />
        <div className="modal-title">
          <p className="title">
            {t("subsidy-section.delete-recurrent-subsidy")}
          </p>
        </div>

        <div className="cob-btn-group center-group">
          <button
            type="button"
            className="cob-btn btn-primary-outline not-uppercase"
            onClick={() => {
              hideModal();
            }}
          >
            {t("actions.cancel")}
          </button>
          <button
            type="button"
            className="cob-btn btn-primary-outline not-uppercase"
            onClick={() => {
              removeRecurrentSubsidy(modelBenefit);
              hideModal();
            }}
          >
            {t("actions.delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

RemoveSubsidyRecurrentModal.defaultProps = {};
RemoveSubsidyRecurrentModal.propTypes = {
  modelBenefit: PropTypes.object.isRequired,
};

export default RemoveSubsidyRecurrentModal;
